import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { UserSettings, GlobalState } from '@leverege/ui-redux';
import { Popup, Toast } from '@leverege/ui-elements';
import { System, AllowedReducer } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import Util from "../Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tf,
  tfIcon,
  tfArray
} = I18N.ns('molten.views.userSettings.SaveToSharedProfiles');
function ProfileRenderer({
  context,
  profiles,
  dispatch,
  canSystem,
  onClose: closeParent
}) {
  const {
    onClose,
    settingsPath,
    value,
    clientProps
  } = context;
  const actionCloseOnExec = clientProps?.actionCloseOnExec;
  useEffect(Util.getCanSystemEffect(dispatch, canSystem), []);
  if (!profiles?.length || !canSystem) {
    return null;
  }
  const saveTo = async evt => {
    try {
      await UserSettings.setSharedProfile(evt.data?.name, settingsPath, value);
      Toast.success([t('successToastTitle'), t('successToastMessage', {
        data: evt.data?.displayName
      })]);
    } catch (err) {
      Toast.error([t('errorToastTitle'), t('errorToastMessage1', {
        data: evt.data?.displayName
      }), t('errorToastMessage2', {
        error: err.message
      })]);
    }
    if (closeParent) closeParent();
    if (onClose && actionCloseOnExec) onClose(evt);
  };
  const saveToAll = async () => {
    return Promise.all(profiles.map(p => saveTo({
      data: p
    })));
  };
  return [...(profiles?.map(v => /*#__PURE__*/_jsx(Popup.Item, {
    onClick: saveTo,
    eventData: v,
    children: v.displayName
  }, v.name)) || []), /*#__PURE__*/_jsx(Popup.Item, {
    onClick: saveToAll,
    children: t('saveToAll')
  }, "___ALL___")];
}
export default {
  id: 'molten.userSetting.titleRight.saveTo.sharedProfiles',
  name: tf('name'),
  matches: {
    use: 'titleRight',
    client: 'UserSettingsEditor',
    managePersonas: true
  },
  handles: context => {
    if (context.simple) {
      return false;
    }
    const sysId = window.Molten.getConfig('api/systemId');
    const val = AllowedReducer.get(GlobalState.get(), System(sysId).resource('ui').getResourceId())?.updateRsrc;
    if (val == null) {
      GlobalState.dispatch(System(sysId).resource('ui').canUpdate()).then(() => context?.editor?.forceUpdate());
    }
    return val;
  },
  layout: {
    group: ['saveTo', 'sharedProfiles'],
    groupIcons: [tfIcon('icon', 'fa fa-upload fa-fw'), null],
    groupNames: tfArray('groupNames'),
    sort: 'aaaa'
  },
  customComponent: connect((state, props) => ({
    profiles: Util.getProfiles(state, props, {
      getProfileFn: 'getSharedProfile',
      getValues: false
    }),
    canSystem: Util.getCanSystem(state, props)
  }))(ProfileRenderer)
};